import * as React from 'react';

function IconMessage(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.15 10.623a1.283 1.283 0 01-1.213-1.78 1.282 1.282 0 111.213 1.78zm-4.095 0a1.283 1.283 0 11-.064-2.566 1.283 1.283 0 01.064 2.566zm-4.095 0a1.283 1.283 0 01-.927-2.2 1.282 1.282 0 11.927 2.2zM10 1.25c-4.86 0-8.815 3.595-8.815 8.014 0 1.892.8 4.466 3.028 6.128l-.263 2.745a.56.56 0 00.825.546l2.859-1.538c.356.037 1.4.133 2.366.133 4.861 0 8.816-3.595 8.816-8.014 0-4.419-3.955-8.014-8.816-8.014z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconMessage = React.memo(IconMessage);
export default MemoIconMessage;
